<template>
    <div>
        <Loading v-if="isLoading"/>
        <template v-else>
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <ol class="breadcrumb">
                            <li><a :href="home_url"> HOME</a>
                            </li>
                            <li>
                                <router-link :to="{name: 'ArtifactsList'}">{{$t('archive')}}</router-link>
                            </li>
                            <li v-if="type !== null">{{type.name}}</li>
                        </ol>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="container">
                    <div class="row">
                        <div class="col-12 content">
                            <h1 v-if="type !== null">{{type.name }}</h1>
                            <section class="area-search">
                                <h2><span>{{$t('narrow_down_by_conditions')}}</span></h2>
                                <dl class="area-search-dl">
                                    <dt>{{$t('search_by_area')}}</dt>
                                    <dd v-if="areas.length > 0">
                                        <ul>
                                            <li v-for="area in areas" :key="area.id">
                                                <a href="javascript:;" @click="addRemoveArea(area.id)" class="r-icon"
                                                   :class="selectedAreas.includes(area.id) ? 'active ' + area.slug : area.slug">{{area.name}}</a>
                                            </li>
                                        </ul>
                                    </dd>
                                </dl>
                                <dl class="remains-search-dl">
                                    <dt>{{$t('search_by_site')}}</dt>
                                    <dd v-if="sites.length > 0">
                                        <ul>
                                            <template v-for="site in sites" :key="site.id">
                                                <li><a href="javascript:;" @click="addRemoveSite(site.id)"
                                                       :class="selectedSites.includes(site.id) ? 'active ' + getAreasBySite(site) : getAreasBySite(site)">
                                                    {{ site.title }}
                                                </a>
                                                </li>
                                            </template>
                                        </ul>
                                    </dd>
                                </dl>
                                <template v-if="typeTags.length > 0">
                                    <dl class="type-search" v-for="(type_tag,index) in typeTags" :key="index">
                                        <dt>
                                            {{$t(type_tag.label)}}
                                        </dt>
                                        <dd v-if="type_tag.tags.length > 0">
                                            <ul>
                                                <li v-for="tag in tagsByFilter(type_tag.tags)" :key="tag.id"><a
                                                    href="javascript:;"
                                                    :class="{active: selectedTags.includes(tag.id)}"
                                                    @click="addRemoveTag(tag.id)">#{{ tag.name}}</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                </template>
                            </section>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="content"><!--ここからコンテンツ-->
                                <section class="new-item">
                                    <h2><span>{{ $t('total_search_result', {total: this.total}) }}</span></h2>
                                    <dl>
                                        <dd>
                                            <AssetList
                                                :key="infiniteId"
                                                :per_page="30"
                                                @setTotal="setTotal"
                                                :show_pagination="true"
                                                :selectedAreas="selectedAreas"
                                                :selectedTypes="selectedTypes"
                                                :selectedSites="selectedSites"
                                                :selectedTags="selectedTags"
                                            />
                                        </dd>
                                    </dl>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import Loading from "../components/Loading";
import axios from "axios";
import AssetList from "../components/AssetList";

export default {
    name: "AssetTypeList",
    components: {AssetList, Loading},
    data() {
        return {
            isLoading: false,
            tagFilters: [],
            assets: [],
            areas: [],
            sites: [],
            tags: [],
            selectedTypes: [this.$route.params.type],
            selectedAreas: [],
            selectedSites: [],
            selectedTags: [],
            lang: lang,
            home_url: home_url,
            type: null,
            total: 0,
            asset_type: this.$route.params.type,
            infiniteId: +new Date()
        }
    },
    computed: {
        typeTags () {
            if(this.asset_type === 'image'){
                return [
                    {label: 'search_by_photo_type', tags: [19,22,35,24]},
                    {label: 'search_from_the_remains', tags: [23,29,38,33,37,36]},
                    {label: 'search_from_excavated_items', tags: [21,26,42,25,30,27,32,28]},
                    {label: 'search_by_season', tags: [40,16,17,18]},
                ]
            }else if(this.asset_type === 'files'){
                return [
                    {label: 'search_by_type', tags: [74,44,78,69,70,71,49,119]}
                ]
            }else if(this.asset_type === 'movie'){
                return [
                    {label: 'search_by_video_type', tags: [76,77,75,79]}
                ]
            }
            return [];
        }
    },
    mounted() {
        window.history.scrollRestoration = "manual"
        window.scrollTo(0, 0)
    },
    created() {
        this.getAssetType()
    },
    methods: {
        tagsByFilter(filter) {
            return this.tags.filter(item => {
                return filter.includes(item.id)
            }).sort(function(item1, item2) {
                return filter.indexOf(item1.id) - filter.indexOf(item2.id);
            })
        },
        getTags() {
            let params = {
                lang: this.lang,
                type: 'asset-tag'
            }
            const config = {
                params: params
            }
            axios.get('/api/terms', config)
                .then((res) => {
                    this.tags = res.data.data
                })
                .finally(() => {
                    this.isLoading = false
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        addRemoveArea(area) {
            if (this.selectedAreas.includes(area)) {
                let index = this.selectedAreas.indexOf(area)
                if (index > -1) {
                    this.selectedAreas.splice(index, 1);
                }
            } else {
                this.selectedAreas.push(area)
            }
            this.infiniteId++
        },
        addRemoveTag(tag) {
            if (this.selectedTags.includes(tag)) {
                let index = this.selectedTags.indexOf(tag)
                if (index > -1) {
                    this.selectedTags.splice(index, 1);
                }
            } else {
                this.selectedTags.push(tag)
            }
            this.infiniteId++
        },
        addRemoveSite(site) {
            if (this.selectedSites.includes(site)) {
                let index = this.selectedSites.indexOf(site)
                if (index > -1) {
                    this.selectedSites.splice(index, 1);
                }
            } else {
                this.selectedSites.push(site)
            }
            this.infiniteId++
        },
        setTotal(total) {
            this.total = total
        },
        getAreasBySite(site) {
            if (site.area.parent !== null) {
                return site.area.parent_slug;
            } else {
                return site.area.slug
            }
        },
        listAreas() {
            let params = {
                lang: this.lang,
                type: 'site-area',
                slugs: 'jomon-archaeological-sites,hokkaido,aomori,iwate,akita'
            }
            const config = {
                params: params
            }
            axios.get('/api/terms', config)
                .then((res) => {
                    this.areas = res.data.data
                })
                .finally(() => {
                    this.getSites()
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        getSites() {
            const config = {
                params: {
                    lang: this.lang
                }
            }
            axios.get('/api/sites', config)
                .then((res) => {
                    this.sites = res.data
                })
                .finally(() => {
                    this.getTags()
                })
        },
        getAssetType() {
            this.isLoading = true
            let params = {
                lang: this.lang,
                type: 'asset-type',
                getAll: true,
                slugs: this.selectedTypes.join()
            }
            const config = {
                params: params
            }
            axios.get('/api/terms', config)
                .then((res) => {
                    this.type = res.data.data[0]
                })
                .finally(() => {
                    this.listAreas()
                })
                .catch((error) => {
                    console.log(error)
                })

        },
    }
}
</script>

<style scoped>

</style>
